import { ControllerInfoUx } from './controller-info-ux.model';
import { ControllerPrefsUx } from './controller-prefs-ux.model';

export class ControllerEditUx
{
    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            if (json.ControllerInfoUx)
            {
                this.ControllerInfoUx = new ControllerInfoUx(json.ControllerInfoUx);
            }

            if (json.ControllerPrefsUx)
            {
                this.ControllerPrefsUx = new ControllerPrefsUx(json.ControllerPrefsUx);
            }

        }
    }

    ControllerInfoUx: ControllerInfoUx;
    ControllerPrefsUx: ControllerPrefsUx;
    ShowMonthlyAdjustment: boolean;
    ShowSyncCommCard: boolean;
}
